var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "webhook-data-item" },
    [
      _c("TiptapEditor", {
        attrs: {
          placeholder: "Data-Key",
          "show-attributes": false,
          "automation-mode": "",
        },
        model: {
          value: _vm.clone.key,
          callback: function ($$v) {
            _vm.$set(_vm.clone, "key", $$v)
          },
          expression: "clone.key",
        },
      }),
      _vm._v(" "),
      _c("TiptapEditor", {
        attrs: {
          placeholder: "Value",
          "show-attributes": true,
          "automation-mode": "",
        },
        model: {
          value: _vm.clone.value,
          callback: function ($$v) {
            _vm.$set(_vm.clone, "value", $$v)
          },
          expression: "clone.value",
        },
      }),
      _vm._v(" "),
      _c(
        "SupsisButton",
        { attrs: { small: "", danger: "" }, on: { click: _vm.deleteItem } },
        [_c("i", { staticClass: "material-icons" }, [_vm._v("delete")])]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }